// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mta-price[data-v-e17d6b4e]{color:#3e4cd4}.price-table[data-v-e17d6b4e]{font-size:1.2rem}.price-table .row[data-v-e17d6b4e]{display:flex;flex-direction:row;padding-bottom:10px}.price-table .row .mta-price[data-v-e17d6b4e]{flex-grow:1;text-align:right}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
